<script lang="ts" setup>
definePageMeta({
  heroBackground: 'opacity-80 -z-10'
})
const [{ data: page }, { data: courses }] = await Promise.all([
  useAsyncData('video-courses-landing', () => useContent('site').get('/video-courses')),
  useAsyncData('video-courses', () => listByDir('/video-courses'))
])

if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

const pageData = computed(() => page.value!.data)

const title = pageData.value.head?.title || pageData.value.title
const description = pageData.value.head?.description || pageData.value.description

useSeoMeta({
  titleTemplate: '%s',
  title,
  description,
  ogDescription: description,
  ogTitle: title
})
useCanonical()
defineOgImage('Docs.takumi', {
  headline: 'Resources',
  title,
  description
})
</script>

<template>
  <UPage v-if="pageData">
    <UPageHero
      :title="pageData.title"
      :description="pageData.description"
      :links="pickLinks(pageData.links)"
    />
    <UPageBody>
      <UContainer>
        <ul class="divide-y divide-default">
          <li v-for="(course, index) in courses" :key="course.slug" class="flex items-center py-3 gap-2">
            <NuxtImg
              :src="`/assets/video-courses/${course.slug}.webp`"
              :alt="course.name"
              :width="'sponsor' in course && course.sponsor ? 94 : 56"
              :height="'sponsor' in course && course.sponsor ? 47 : 28"
              format="webp"
              :modifiers="{ position: 'top' }"
              :loading="index > 3 ? 'lazy' : undefined"
              class="rounded border border-default object-cover mr-2 hidden lg:block"
            />
            <h3
              class="font-medium text-highlighted text-nowrap flex-grow lg:flex-grow-0"
              :class="'sponsor' in course && course.sponsor ? 'text-xl' : 'text-base'"
            >
              {{ course.name }}
            </h3>
            <p
              class="text-muted hidden lg:block flex-grow truncate"
              :class="'sponsor' in course && course.sponsor ? 'text-base' : 'text-sm'"
            >
              {{ course.description }}
            </p>
            <UBadge
              v-if="course.badge"
              :label="course.badge"
              variant="subtle"
              class="rounded-full"
            />
            <UBadge
              v-else
              label="Free"
              color="info"
              variant="subtle"
              class="rounded-full"
            />
            <UButton
              v-if="'sponsor' in course && course.sponsor"
              :to="course.url"
              target="_blank"
              trailing-icon="i-lucide-arrow-right"
              size="sm"
              color="success"
              label="Discover course"
            />
            <UButton
              v-else
              :to="course.url"
              target="_blank"
              trailing-icon="i-lucide-arrow-right"
              variant="link"
              size="sm"
              color="neutral"
              label="Discover course"
            />
          </li>
        </ul>
      </UContainer>
    </UPageBody>
  </UPage>
</template>
